// import React, { useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';

// function Developers({ mapWidth, mapHeight, developersSvg }) {
//   const navigate = useNavigate();

//   const { defsHtml, bodyHtml } = useMemo(() => {
//     if (!developersSvg) return { defsHtml: '', bodyHtml: '' };

//     try {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(developersSvg, 'image/svg+xml');
//       if (doc.querySelector('parsererror')) {
//         return { defsHtml: '', bodyHtml: '' };
//       }

//       const defs = doc.querySelector('defs');
//       const defsHtml = defs ? defs.outerHTML : '';

//       // نأخذ كل محتوى الـ svg (مش zones بس)
//       const svg = doc.querySelector('svg');
//       if (!svg) return { defsHtml, bodyHtml: '' };

//       // نشيل defs من الجسم عشان ما تتكرر
//       defs?.remove();

//       const bodyHtml = svg.innerHTML;

//       return { defsHtml, bodyHtml };
//     } catch (e) {
//       console.error(e);
//       return { defsHtml: '', bodyHtml: '' };
//     }
//   }, [developersSvg]);

//   if (!bodyHtml) return null;

//   return (
//     <svg
//       width={mapWidth}
//       height={mapHeight}
//       viewBox="0 0 8192 8192"
//       preserveAspectRatio="xMidYMid meet"
//       style={{
//         position: 'absolute',
//         inset: 0,
//         pointerEvents: 'none', // الماب يفضل يتحرك
//       }}
//     >
//       {/* defs */}
//       <g dangerouslySetInnerHTML={{ __html: defsHtml }} />
//       <g
//         dangerouslySetInnerHTML={{ __html: bodyHtml }}
//         onTouchStart={(e) => {
//           const zone = e.target.closest('[data-zone]');
//           if (zone) {
//             e.stopPropagation();
//             const id = zone.getAttribute('data-zone');
//             if (id) navigate(`/master-plan/${id}`);
//           }
//         }}

//         onMouseMove={(e) => {
//           const zone = e.target.closest('[data-zone]');
//           if (zone) zone.style.cursor = 'pointer';
//         }}
//         onMouseLeave={(e) => {
//           const zone = e.target.closest('[data-zone]');
//           if (zone) zone.style.cursor = 'default';
//         }}
//         onMouseDown={(e) => {
//           if (e.target.closest('[data-zone]')) {
//             e.stopPropagation();
//             e.preventDefault();
//           }
//         }}
//         onClick={(e) => {
//           const zone = e.target.closest('[data-zone]');
//           if (!zone) return;

//           e.stopPropagation();
//           e.preventDefault();

//           const id = zone.getAttribute('data-zone');
//           if (id) navigate(`/master-plan/${id}`);
//         }}
//         style={{
//           pointerEvents: 'auto',
//         }}
//       />
//     </svg>
//   );
// }

// export default Developers;
import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function Developers({ mapWidth, mapHeight, developersSvg }) {
  const navigate = useNavigate();
  // 🎯 سحب الـ slug من الـ URL (مثلاً: sadan)
  const { projectSlug } = useParams();

  const { defsHtml, bodyHtml } = useMemo(() => {
    if (!developersSvg) return { defsHtml: '', bodyHtml: '' };

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(developersSvg, 'image/svg+xml');
      if (doc.querySelector('parsererror')) {
        return { defsHtml: '', bodyHtml: '' };
      }

      const defs = doc.querySelector('defs');
      const defsHtml = defs ? defs.outerHTML : '';

      const svg = doc.querySelector('svg');
      if (!svg) return { defsHtml, bodyHtml: '' };

      // إزالة الـ defs من المتن لتجنب التكرار
      const defsInSvg = svg.querySelector('defs');
      if (defsInSvg) defsInSvg.remove();

      const bodyHtml = svg.innerHTML;

      return { defsHtml, bodyHtml };
    } catch (e) {
      console.error("SVG Parsing Error:", e);
      return { defsHtml: '', bodyHtml: '' };
    }
  }, [developersSvg]);

  // دالة موحدة للتعامل مع الانتقال للـ Zone
  const handleNavigation = (e) => {
    const zoneElement = e.target.closest('[data-zone]');
    if (!zoneElement) return;

    // منع انتشار الحدث للخريطة الخلفية
    e.stopPropagation();
    if (e.type === 'click' || e.type === 'mousedown') {
        e.preventDefault();
    }

    const zoneId = zoneElement.getAttribute('data-zone');

    // 🚀 التعديل الأهم: بناء المسار الجديد باستخدام الـ projectSlug
    if (zoneId && projectSlug) {
      console.log(`🔗 Navigating to Zone: ${zoneId} in Project: ${projectSlug}`);
      navigate(`/${projectSlug}/master-plan/${zoneId}`);
    } else {
      console.warn("⚠️ Missing zoneId or projectSlug", { zoneId, projectSlug });
    }
  };

  if (!bodyHtml) return null;

  return (
    <svg
      width={mapWidth}
      height={mapHeight}
      viewBox="0 0 8192 8192"
      preserveAspectRatio="xMidYMid meet"
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none', // السماح بحركة الخريطة في المناطق الفارغة
      }}
    >
      {/* حقن الـ Defs (Styles, Filters, etc.) */}
      <g dangerouslySetInnerHTML={{ __html: defsHtml }} />

      {/* حقن جسم الـ SVG مع مستمعات الأحداث */}
      <g
        dangerouslySetInnerHTML={{ __html: bodyHtml }}
        style={{ pointerEvents: 'auto' }} // السماح بالتفاعل مع الـ Zones فقط
        onClick={handleNavigation}
        onTouchStart={handleNavigation}
        onMouseMove={(e) => {
          const zone = e.target.closest('[data-zone]');
          if (zone) zone.style.cursor = 'pointer';
        }}
        onMouseLeave={(e) => {
          const zone = e.target.closest('[data-zone]');
          if (zone) zone.style.cursor = 'default';
        }}
        onMouseDown={(e) => {
          if (e.target.closest('[data-zone]')) {
            e.stopPropagation();
          }
        }}
      />
    </svg>
  );
}

export default Developers;